import * as React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box } from '@mui/material';
import { useState } from 'react';
import RecordLicenseFormContainer from '../../../containers/employeemng/resume/RecordLicenseFormContainer';
import RecordLicenseListContainer from '../../../containers/employeemng/resume/RecordLicenseListContainer';
import TechMgtFormContainer from '../../../containers/employeemng/resume/TechMgtFormContainer';
import TechMgtListContainer from '../../../containers/employeemng/resume/TechMgtListContainer';
import RewardPunishmentListContainer from '../../../containers/employeemng/resume/RewardPunishmentListContainer';
import RewardPunishmentFormContainer from '../../../containers/employeemng/resume/RewardPunishmentFormContainer';
import KPIListContainer from '../../../containers/employeemng/resume/KPIListContainer';
import KPIFormContainer from '../../../containers/employeemng/resume/KPIFormContainer';
import RNRListContainer from '../../../containers/employeemng/resume/RNRListContainer';
import RNRFormContainer from '../../../containers/employeemng/resume/RNRFormContainer';
import CounselListContainer from '../../../containers/employeemng/resume/CounselListContainer';
import CounselFormContainer from '../../../containers/employeemng/resume/CounselFormContainer';
import CounselTemplate from './CounselTemplate';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`resume-tabpanel-${index}`}
      aria-labelledby={`resume-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `resume-tab-${index}`,
    'aria-controls': `resume-tabpanel-${index}`,
  };
}

const ResumeTabs = ({ employee, edit }) => {
  const [selectTab, setSelectTab] = useState(0);
  const handleChange = (event, newTab) => {
    setSelectTab(newTab);
  };
  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectTab}
            onChange={handleChange}
            aria-label="resumen tabs"
          >
            <Tab label="업무정의" {...a11yProps(0)} />
            <Tab label="기술관리" {...a11yProps(1)} />
            <Tab label="개인자격증" {...a11yProps(2)} />
            <Tab label="개인면담일지" {...a11yProps(3)} />
            <Tab label="KPI 평가" {...a11yProps(4)} />
            <Tab label="상벌조항" {...a11yProps(5)} />
          </Tabs>
        </Box>

        <TabPanel value={selectTab} index={0}>
          {edit && <RNRFormContainer employee={employee} />}
          <RNRListContainer employee={employee} />
        </TabPanel>
        <TabPanel value={selectTab} index={1}>
        {edit && <TechMgtFormContainer employee={employee} />}
          <TechMgtListContainer employee={employee} />
        </TabPanel>
        <TabPanel value={selectTab} index={2}>
        {edit && (<RecordLicenseFormContainer employee={employee} />)}
          <RecordLicenseListContainer employee={employee} />
        </TabPanel>
        <TabPanel value={selectTab} index={3}>
        {/* {edit && <CounselFormContainer employee={employee} />}
          <CounselListContainer employee={employee} /> */}
          <CounselTemplate edit  employee={employee}/>
        </TabPanel>
        <TabPanel value={selectTab} index={4}>
        {edit && <KPIFormContainer employee={employee} />}
          <KPIListContainer employee={employee} />
        </TabPanel>
        <TabPanel value={selectTab} index={5}>
        {edit && <RewardPunishmentFormContainer employee={employee} />}
          <RewardPunishmentListContainer employee={employee} />
        </TabPanel>
      </Box>
    </div>
  );
};

export default ResumeTabs;
